import { ProfileUserInitials } from '@apps-common/components/common/user'
import { VertSpacerLg, VertSpacerSm } from '@apps-common/components/layout'
import { commonIcons } from '@apps-common/config/icons'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { IMyMonitoringAccountListModel } from '@apps-common/types/portal/my-monitoring'
import { ROUTE_MY_MONITORING_ACCOUNT_DETAILS } from '@apps-radionet-portal-root/src/config/private-routes'
import { MyMonitoringAccountSitePills } from '../MyMonitoringAccountSitePills'

interface IProps {
  account: IMyMonitoringAccountListModel
}
export const MyMonitoringAccountListCard = ({ account }: IProps) => {
  const { id, email, firstName, lastName, unitCount } = account
  const { navigateForward } = useNavigation()

  return (
    <div className='relative p-6 rounded-[35px] bg-surface text-text border border-border overflow-hidden'>
      <div className='relative flex items-center justify-between'>
        <div className='jost text-nowrap text-ellipsis overflow-hidden max-w-[55%]'>{email}</div>
        <ProfileUserInitials classes='' name={`${firstName} ${lastName}`} />
      </div>
      <div className='flex flex-col gap-[12px] text-[0.9em]'>
        <VertSpacerSm />
        <div className='flex items-center justify-start gap-[10px] capitalize'>
          <div className='whitespace-nowrap grow flex items-center justify-start gap-[10px] capitalize'>
            <p className='jost-light text-md text-ellipsis overflow-hidden bg-surface-2 text-text border border-border text-[0.9em] leading-[1em] p-1 rounded'>
              Name
            </p>
            <p className='jost-light text-sm text-ellipsis overflow-hidden'>
              {firstName} {lastName}
            </p>
          </div>

          <p className='jost-light text-md flex items-center justify-end gap-[5px] text-ellipsis overflow-hidden bg-surface-2 text-text border border-border text-[0.9em] leading-[1em] p-1 rounded-full'>
            <div className='flex items-center justify-center'>
              <div className='flex items-center justify-center bg-surface-2 text-text rounded-full px-[5px] pt-[3px] pb-[2px] min-w-[18px] h-[18px]'>
                {unitCount} {unitCount === 1 ? 'Device' : 'Devices'}
              </div>
            </div>
          </p>
        </div>
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize'>
          <MyMonitoringAccountSitePills props={account} take={4} />
        </div>
      </div>
      <VertSpacerLg />
      <button
        type='button'
        className='w-full action-brand ring-1 grow flex items-center justify-between gap-[5px] jost text-[0.8rem] !pl-[15px] !p-[5px] h-[35px] rounded-full'
        onClick={(e) => {
          e?.stopPropagation()
          navigateForward({
            routeUrl: ROUTE_MY_MONITORING_ACCOUNT_DETAILS.buildPath(id),
            route: ROUTE_MY_MONITORING_ACCOUNT_DETAILS
          })
        }}
      >
        Details
        <div className='bg-brand text-on-brand w-[26px] h-[26px] rounded-[13px] flex items-center justify-center'>
          <commonIcons.arrowAngled className='text-[0.9rem]' />
        </div>
      </button>
    </div>
  )
}
